import omitDeep from './omit-deep';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeTypename = (val: Record<string, any> | Record<string, any>[]) =>
  omitDeep(val, '__typename');

export default removeTypename;
